import React from "react";
import Boutique from "./components/Boutique";
import "./styles/Boutique.css";
export default function App() {
  return <Boutique />;
}
